import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_AWARD_MUTATION } from '../graphql/mutations'
import { DELETE_AWARD } from '../redux/action-types'

const useDeleteAwardMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.awards.awards)

  const mutate = useCallback(
    async id => {
      await apolloService.mutate(
        DELETE_AWARD_MUTATION,
        {
          id,
        },
        dispatch,
        DELETE_AWARD,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteAwardMutation
